/**
 * @generated SignedSource<<f2cd900762616fa1d704834315767d64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Chain = "Arbitrum" | "Ethereum" | "Optimism" | "POAP" | "Polygon" | "Tezos" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ManageWalletsFragment$data = {
  readonly viewer: {
    readonly user?: {
      readonly wallets: ReadonlyArray<{
        readonly chainAddress: {
          readonly address: string;
          readonly chain: Chain;
        };
        readonly dbid: string;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ManageWalletsFragment";
};
export type ManageWalletsFragment$key = {
  readonly " $data"?: ManageWalletsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageWalletsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageWalletsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Wallet",
                  "kind": "LinkedField",
                  "name": "wallets",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dbid",
                        "storageKey": null
                      },
                      "action": "THROW",
                      "path": "viewer.user.wallets.dbid"
                    },
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChainAddress",
                        "kind": "LinkedField",
                        "name": "chainAddress",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "address",
                              "storageKey": null
                            },
                            "action": "THROW",
                            "path": "viewer.user.wallets.chainAddress.address"
                          },
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "chain",
                              "storageKey": null
                            },
                            "action": "THROW",
                            "path": "viewer.user.wallets.chainAddress.chain"
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "THROW",
                      "path": "viewer.user.wallets.chainAddress"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bd53e1fa036fb8200147e56799ababfa";

export default node;
